// src/components/StoreSettings.js
import { useState, useEffect } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../AuthContext";

export const DEFAULT_STORES = ["Amazon", "Home Depot", "Lowe's", "Menards"];

export function useEnabledStores() {
  const { user } = useAuth();
  const [enabledStores, setEnabledStores] = useState(DEFAULT_STORES);

  useEffect(() => {
    if (!user) return;
    getDoc(doc(db, "users", user.uid)).then(snap => {
      if (snap.exists() && snap.data().enabledStores) {
        setEnabledStores(snap.data().enabledStores);
      }
    }).catch(() => {});
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  return enabledStores;
}

export default function StoreSettings() {
  const { user } = useAuth();
  const [enabled, setEnabled] = useState(DEFAULT_STORES);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState("");

  const STORE_INFO = [
    { name: "Amazon",     color: "#FF9900", desc: "Widest selection, fast shipping" },
    { name: "Home Depot", color: "#F96302", desc: "In-store pickup available" },
    { name: "Lowe's",     color: "#004990", desc: "In-store pickup available" },
    { name: "Menards",    color: "#00833d", desc: "Midwest stores, great prices" },
  ];

  useEffect(() => {
    if (!user) return;
    getDoc(doc(db, "users", user.uid)).then(snap => {
      if (snap.exists() && snap.data().enabledStores) {
        setEnabled(snap.data().enabledStores);
      }
    }).catch(() => {});
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  function toggleStore(name) {
    setEnabled(prev => prev.includes(name) ? prev.filter(s => s !== name) : [...prev, name]);
  }

  async function handleSave() {
    if (enabled.length === 0) { alert("Please enable at least one store."); return; }
    setSaving(true);
    try {
      await setDoc(doc(db, "users", user.uid), { enabledStores: enabled }, { merge: true });
      setSuccess("Saved!"); setTimeout(() => setSuccess(""), 3000);
    } catch (err) { console.error(err); }
    finally { setSaving(false); }
  }

  return (
    <div>
      <h3 style={{ fontFamily: "'Fredoka One', cursive", fontSize: 20, color: "#8B4513", marginBottom: 6 }}>Parts List Stores</h3>
      <p style={{ fontSize: 13, color: "#a07850", fontWeight: 600, marginBottom: 16 }}>Choose which stores appear in your AI-generated parts lists.</p>
      {success && <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", color: "#166534", borderRadius: 10, padding: "10px 14px", fontSize: 13, fontWeight: 700, marginBottom: 14 }}>{success}</div>}
      <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 16 }}>
        {STORE_INFO.map(({ name, color, desc }) => {
          const isOn = enabled.includes(name);
          return (
            <div key={name} onClick={() => toggleStore(name)}
              style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 16px", borderRadius: 12, cursor: "pointer", border: `2px solid ${isOn ? color : "#e8d5b8"}`, background: isOn ? color + "12" : "white", transition: "all 0.18s" }}>
              <div style={{ width: 22, height: 22, borderRadius: 6, flexShrink: 0, border: `2.5px solid ${isOn ? color : "#d4a96a"}`, background: isOn ? color : "white", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.18s" }}>
                {isOn && <span style={{ color: "white", fontSize: 13, fontWeight: 900 }}>✓</span>}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 800, fontSize: 14, color: isOn ? color : "#2c1810" }}>{name}</div>
                <div style={{ fontSize: 12, color: "#a07850", fontWeight: 600 }}>{desc}</div>
              </div>
              <div style={{ fontSize: 11, fontWeight: 800, padding: "3px 10px", borderRadius: 20, background: isOn ? color : "#f5ead8", color: isOn ? "white" : "#a07850" }}>
                {isOn ? "ON" : "OFF"}
              </div>
            </div>
          );
        })}
      </div>
      <button className="btn-primary" onClick={handleSave} disabled={saving} style={{ width: "100%" }}>
        {saving ? "Saving..." : "Save Store Preferences"}
      </button>
    </div>
  );
}
